import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'
import {
  Paper,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'

import { sortTimeseriesByTitle } from '../../utils/sorting'
import { timeseriesConfig } from '../../utils/TimeseriesConfig'

class TimeseriesSummaryView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    timeseries: PropTypes.array,
    onClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    timeseries: [],
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16,
      marginTop: theme.spacing(3),
    }),
    icon: {
      textAlign: 'center',
    },
    table: {
      '& a': theme.a,
    },
    clickable: theme.clickable,
  })

  renderTimeseries = (ts) => {
    const { classes, onClick } = this.props
    const tsConfig = timeseriesConfig(ts.name)
    const lastUpdated = moment(ts.last_updated)

    return (
      <TableRow key={`${ts.id}`} className={classes.clickable} onClick={() => { onClick(ts) }}>
        <TableCell padding="none" className={classes.icon}>
          <SvgIcon>
            <path d={tsConfig.icon} />
          </SvgIcon>
        </TableCell>
        <TableCell>
          <a onClick={() => { onClick(ts) }}>
            {ts.title || ts.name}
          </a>
        </TableCell>
        <TableCell>{lastUpdated.unix() > 0 ? tsConfig.format(ts.current_value.value) : '-'}</TableCell>
        <TableCell>{lastUpdated.unix() > 0 ? lastUpdated.calendar() : '-'}</TableCell>
        <TableCell>{ts.description}</TableCell>
      </TableRow>
    )
  }

  render() {
    const { classes, timeseries } = this.props

    // Sort by title
    const timeseriesSorted = sortTimeseriesByTitle(timeseries)

    const tsHtml = timeseriesSorted.map(this.renderTimeseries)

    return (
      <Paper className={classes.paper} elevation={0}>
        <Typography variant="h6">Current Status</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell padding="none" />
              <TableCell>Name</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Last Updated</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tsHtml}
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(TimeseriesSummaryView.styles)(TimeseriesSummaryView)
